import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ClipboardCheck, ChevronRight, Clock, Sparkles } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function MyEvaluationsWidget() {
  const t = useT();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get("/evaluations/me")
      .then((r) => { if (!cancelled) setItems(r.data.items || []); })
      .catch(() => { /* silent */ })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  if (loading || items.length === 0) return null;
  const pending = items.filter((i) => !i.completed);
  if (pending.length === 0) return null;

  return (
    <div
      data-testid="my-evaluations-widget"
      className="bg-gradient-to-br from-[#1B2E7A] to-[#13205A] text-white rounded-2xl p-5 mb-10 fade-up"
    >
      <div className="flex items-start justify-between gap-3 mb-3 flex-wrap">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-md bg-white/10 flex items-center justify-center shrink-0">
            <ClipboardCheck className="h-5 w-5 text-white" strokeWidth={1.5} />
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.22em] text-white/70 mb-0.5">{t("widget.eval.eyebrow")}</p>
            <h3 className="font-heading text-xl text-white leading-tight">
              {t("widget.eval.title", { n: pending.length })}
            </h3>
            <p className="text-sm text-white/75 mt-0.5">{t("widget.eval.subtitle")}</p>
          </div>
        </div>
        <Link
          to="/evaluaciones"
          className="inline-flex items-center gap-1 text-sm text-white bg-white/10 hover:bg-white/20 px-4 py-2 rounded-md transition-colors"
          data-testid="widget-eval-cta"
        >
          {t("widget.eval.go")} <ChevronRight className="h-4 w-4" />
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 mt-4">
        {pending.slice(0, 3).map((it) => (
          <Link
            key={it.evaluation.id}
            to="/evaluaciones"
            className="bg-white/5 hover:bg-white/10 border border-white/10 rounded-lg p-3 transition-colors"
            data-testid={`widget-pending-${it.evaluation.id}`}
          >
            <p className="text-sm font-medium text-white line-clamp-1">{it.evaluation.title}</p>
            <div className="flex items-center gap-2 text-[10px] text-white/60 mt-1">
              <span className="inline-flex items-center gap-0.5">
                <Clock className="h-3 w-3" /> {it.evaluation.duration_minutes} min
              </span>
              <span>·</span>
              <span>{it.evaluation.questions_count} {t("eval.questions")}</span>
              {it.evaluation.target === "manager" && (
                <span className="ml-auto inline-flex items-center gap-0.5 text-[#F4B81F]">
                  <Sparkles className="h-3 w-3" /> {t("widget.eval.manager")}
                </span>
              )}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
